import { z } from "zod"
import { useState } from "react"
import { BackupMethods } from "@portal-hq/web"
import CreateWalletForm from "./create-wallet.form"
import Loader from "@/components/layout/loader"
import { formSchema } from "./create-wallet-form.schema"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Progress } from "@/components/ui/progress"
import { usePortal } from "@/state/stores/wallet.store"
import { useWalletsActions } from "@/api/wallets"

const BACKUP_STEPS = 8

export function WalletSetPassword() {
  const [step, setStep] = useState<"form" | "processing" | "done">("form")
  const portal = usePortal()
  const [progress, setProgress] = useState<number>(0)
  const { updateBackups } = useWalletsActions()

  if (!portal) return null

  const onSubmit = async ({ password }: z.infer<typeof formSchema>) => {
    setStep("processing")

    const backupConfigs = { passwordStorage: { password } }
    const backupMethod = BackupMethods.password

    const { cipherText } = await portal.backupWallet(
      backupMethod,
      () => setProgress((progress: number) => progress + 1),
      backupConfigs,
    )
    setProgress((progress: number) => progress + 1)
    await updateBackups(backupMethod, cipherText)
    await portal.storedClientBackupShare(true, backupMethod)
    setProgress((progress: number) => progress + 1)
    setStep("done")
  }

  if (step === "processing") {
    return (
      <div className="flex gap-4 flex-col">
        <Loader message="Updating wallet secret PIN, this can take a minute..." />
        <Progress value={(progress * 100) / BACKUP_STEPS} />
      </div>
    )
  } else if (step === "form") {
    return <CreateWalletForm onSubmit={onSubmit} />
  } else if (step === "done") {
    return (
      <Alert variant="success">
        <AlertTitle>Done!</AlertTitle>
        <AlertDescription>
          Your wallet secret PIN has been updated successfully.
        </AlertDescription>
      </Alert>
    )
  }
}
